import { AfterContentInit, Component, Inject } from '@angular/core';
import { AuxDataAccountsTableColumnDirective } from '../auxiliary-data-accounts-table-column.directive';

@Component({
  template: `
    <div class="column">
      <ng-container *ngIf="element?.accountName; else deletedAccount">
        <a routerLink="/{{ accountUrl }}">{{ element.accountName }}</a>
      </ng-container>
      <ng-template #deletedAccount>
        {{ 'AUXILIARY_DATA_TABLE.DELETED_ACCOUNT' | translate }}
      </ng-template>
      <div>
        <span class="address">{{ address }}</span>
      </div>
    </div>
  `,
  styleUrls: ['account-name-column.component.scss'],
  standalone: false,
})
export class AccountNameColumnComponent extends AuxDataAccountsTableColumnDirective implements AfterContentInit {
  accountUrl: string;
  address = '';

  constructor(@Inject('ACCOUNT_DETAILS_URL') private accountDetails: string) {
    super();
  }

  ngAfterContentInit(): void {
    if (this.element?.address?.address) {
      if (this.address !== '') {
        this.address += ', ';
      }
      this.address += this.element?.address?.address;
    }
    if (this.element?.address?.address2) {
      if (this.address !== '') {
        this.address += ', ';
      }
      this.address += this.element?.address?.address2;
    }
    if (this.element?.address?.postalCode) {
      if (this.address !== '') {
        this.address += ', ';
      }
      this.address += this.element?.address?.postalCode;
    }
    if (this.element?.address?.postalCode) {
      if (this.address !== '') {
        this.address += ', ';
      }
      this.address += this.element?.address?.country;
    }
    this.accountUrl = this.accountDetails.replace('${account_group_id}', this.element.accountGroupId);
  }
}
